import QueryString from "qs";
import BlogDetails from "@/Components/pages/blog/detail";
import HocHead from "@/Components/HigherOrderComponent/HocHead";
import { getArticleRoutePrefix } from "@/utils/common";
import { GetServerSideProps, NextPage } from "next";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

interface NewsroomDetailProps {
  apiResData: any;
  slug: string;
  isNew: boolean;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }
  const slug = ctx?.params?.slug as string;

  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep,6",
    },
    {
      encodeValuesOnly: false,
    }
  );
  const apiRes = await fetch(`${baseUrl}articles?${decodeURIComponent(query)}`);
  const apiResData = await apiRes.json();

  if (apiResData?.data?.length === 0) {
    return {
      notFound: true,
    };
  }

  // Redirect to the canonical route prefix (blog/whitepaper/newsroom) to
  // avoid the same article being reachable/indexable under multiple URLs.
  const canonicalPrefix = getArticleRoutePrefix(apiResData?.data?.[0]?.attributes);
  if (canonicalPrefix !== "newsroom") {
    return {
      redirect: {
        permanent: true,
        destination: `/${canonicalPrefix}/${slug}`,
      },
    };
  }

  const isNew = apiResData?.data[0]?.attributes?.design === "new";
  return {
    props: {
      apiResData,
      slug,
      isNew,
    },
  };
};

const NewsroomDetail: NextPage<NewsroomDetailProps> = ({ apiResData }) => {
  const seo = apiResData.data[0]?.attributes.seo;
  const data = apiResData.data[0]?.attributes;

  return (
    <div id="root">
      {seo && (
        <HocHead seo={seo}>
          <meta
            data-head="tezjs"
            property="article:published_time"
            content={data.publish_at}
          />
          <meta
            data-head="tezjs"
            property="article:modified_time"
            content={data.updatedAt}
          />
          <meta data-head="tezjs" property="og:type" content="article" />
          <meta data-head="tezjs" property="og:locale" content="en_US" />
          <meta data-head="tezjs" property="og:site_name" content="TRooTech" />
          <meta
            name="author"
            content={data.authors.data[0].attributes.fullname}
          />
        </HocHead>
      )}

      <div>
        <BlogDetails blocks={apiResData} />
      </div>
    </div>
  );
};

export default NewsroomDetail;
